import api from "../../api/index";

const getnotifications = `${process.env.VUE_APP_BASE_URI}/enterprise/notifications`;
const getcriticalnotifications = `${process.env.VUE_APP_BASE_URI}/enterprise/criticals`;
const getlog = `${process.env.VUE_APP_BASE_URI}/audit-log`;

const getDefaultState = () => {
  return {
    notifications: [],
    sortednotifications: [],
    criticals: [],
    logs: [],
    status: "",
    filteredNotfications: [],
    paginationMeta: {},
  };
};

const state = getDefaultState();

const getters = {
  notifications: (state) => state.notifications,
  sortednotifications: (state) => state.sortednotifications,
  criticals: (state) => state.criticals,
  logs: (state) => state.logs,
  filteredNotfications: (state) => state.filteredNotfications,
  logspaginationMeta: (state) => state.paginationMeta,
  getNotificationspaginationMeta: (state) => state.paginationMeta,
};

const actions = {
  async getNotifications({ commit }, params) {
    commit("getnotifications_request");
    const res = await api.get(getnotifications, { params });
    if (res.data.success) {
      commit("getnotifications_success", res.data);
    }
    return res;
  },
  async getSearchedNotifications({ commit }, params) {
    const res = await api.get(`${getnotifications}/search`, { params });
    if (res.data.success) {
      commit("getnotifications_success", res.data);
    }
    return res;
  },
  async getSortedNotifications({ commit }, { imei, period }) {
    commit("getsortednotifications_request");
    const res = await api.post(`${getnotifications}/${imei}`, period);
    if (res.data.success) {
      commit("getsortednotifications_success", res.data.stats);
    }
    return res;
  },
  async getCriticals({ commit }) {
    commit("getcriticals_request");
    const res = await api.get(getcriticalnotifications);
    if (res.data.success) {
      commit("getcriticals_success", res.data.notifications);
    }
    return res;
  },

  async getLogs({ commit }, params) {
    commit("getlogs_request");
    const res = await api.get(getlog, { params });
    if (res.data.success) {
      commit("getlogs_success", res.data.payload);
    }
    return res;
  },

  async getSearchedLogs({ commit }, params) {
    commit("getlogs_request");
    const res = await api.get(`${getlog}/search`, { params });
    if (res.data.success) {
      commit("getlogs_success", res.data);
    }
    return res;
  },

  async getFilteredNotifications({ commit }, period) {
    commit("getFilteredNotifications_request");
    const res = await api.post(getnotifications, period);
    if (res.data.success) {
      commit("getFilteredNotifications_success", res.data.notifications);
    }
    return res;
  },

  async resetNotificationsState({ commit }) {
    await commit("resetnotificationsstate_success");
  },
};

const mutations = {
  getnotifications_request: (state) => (state.status = "loading"),
  getnotifications_success: (state, data) => {
    state.status = "success";
    state.notifications = data.notifications;
    state.paginationMeta = data.paginationMeta;
  },
  getsortednotifications_request: (state) => (state.status = "loading"),
  getsortednotifications_success: (state, notifications) => {
    (state.status = "success"), (state.sortednotifications = notifications);
  },
  getcriticals_request: (state) => (state.status = "loading"),
  getcriticals_success: (state, criticals) => {
    (state.status = "success"), (state.criticals = criticals);
  },
  getlogs_request: (state) => (state.status = "loading"),
  getlogs_success: (state, data) => {
    state.status = "success";
    state.logs = data.data;
    state.paginationMeta = data.meta;
  },
  getFilteredNotifications_request: (state) => (state.status = "loading"),
  getFilteredNotifications_success: (state, data) => {
    (state.status = "success"), (state.filteredNotfications = data);
  },
  resetnotificationsstate_success: (state) =>
    Object.assign(state, getDefaultState()),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
